import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const SaveIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17 3L5 3C3.89 3 3 3.9 3 5L3 19C3 20.1 3.89 21 5 21L19 21C20.1 21 21 20.1 21 19L21 7L17 3ZM19 19L5 19L5 5L16.17 5L19 7.83L19 19ZM12 12C10.34 12 9 13.34 9 15S10.34 18 12 18S15 16.66 15 15C15 13.34 13.66 12 12 12ZM6 6L15 6L15 10L6 10L6 6Z"
      fill="currentColor"
    />
  </svg>
);

SaveIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(SaveIcon);
